import { Empty, Timeline } from "antd";

import type { AuditEntry } from "@/views/PlanOfRecord/planOfRecordData";

const ACTION_COLOR: Record<AuditEntry["action"], string> = {
  created: "green",
  updated: "blue",
  deleted: "red",
};

function formatTimestamp(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function AuditTimeline({ entries }: { entries: AuditEntry[] }) {
  if (entries.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="No changes recorded yet — this value is as it was first entered."
      />
    );
  }

  return (
    <Timeline
      items={entries.map((entry) => ({
        key: entry.id,
        color: ACTION_COLOR[entry.action],
        content: (
          <div className="text-[13px]">
            <div>
              <span className="font-semibold text-[#1F2933]">
                {entry.actor}
              </span>
              {entry.actorRole ? (
                <span className="text-[#6B7280]"> · {entry.actorRole}</span>
              ) : null}
            </div>
            <div className="text-[12px] text-[#8AA0A9]">
              {formatTimestamp(entry.at)}
            </div>
            <div className="mt-1 text-[#374151]">
              <span className="capitalize">{entry.action}</span>
              {entry.field ? (
                <span className="text-[#6B7280]"> · {entry.field}</span>
              ) : null}
            </div>
            {entry.priorValue || entry.newValue ? (
              <div className="mt-1">
                {entry.priorValue ? (
                  <span className="text-[#6B7280] line-through">
                    {entry.priorValue}
                  </span>
                ) : (
                  <span className="text-[#8AA0A9]">(not set)</span>
                )}
                <span className="text-[#8AA0A9]"> → </span>
                <span className="font-semibold text-[#1F2933]">
                  {entry.newValue ?? "(cleared)"}
                </span>
              </div>
            ) : null}
            {entry.rationale ? (
              <div className="mt-1 italic text-[#374151]">
                “{entry.rationale}”
              </div>
            ) : null}
          </div>
        ),
      }))}
    />
  );
}
